import TempPasswordModal from './TempPasswordModal'

export default TempPasswordModal
